export const CONTENT_EDITOR_LOADED_ACTION = 'content_editor_loaded';
export const WIKI_CONTENT_EDITOR_TRACKING_LABEL = 'wiki_content_editor';
export const WIKI_FORMAT_LABEL = 'wiki_format';
export const WIKI_FORMAT_UPDATED_ACTION = 'wiki_format_updated';
export const WIKI_CONTAINER_TYPE = {
  PROJECT: 'project',
  GROUP: 'group',
};
